import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import { useLocalSearchParams } from "expo-router";
import React from "react";
import { ScrollView, View } from "react-native";
import Markdown from "react-native-markdown-display";
import Loader from "@/elements/components/shared/loader";
import ResponsiveContent from "@/elements/components/shared/responsive-content";
import { AppBar } from "@/elements/components/ui/app-bar";
import { api } from "@/elements/components/utils/convex-api";
import goBack from "@/elements/components/utils/go-back";

const markdownStyles = {
  body: { fontFamily: "Geologica_400Regular", color: "#181718" },
  heading1: { fontFamily: "Geologica_500Medium", color: "#181718" },
  heading2: { fontFamily: "Geologica_500Medium", color: "#181718" },
  heading3: { fontFamily: "Geologica_500Medium", color: "#181718" },
  heading4: { fontFamily: "Geologica_500Medium", color: "#181718" },
  heading5: { fontFamily: "Geologica_500Medium", color: "#181718" },
  heading6: { fontFamily: "Geologica_500Medium", color: "#181718" },
  text: { color: "#181718" },
  strong: { fontFamily: "Geologica_500Medium", color: "#181718" },
};

function LegalDocumentDetailScreen() {
  const { documentType } = useLocalSearchParams<{ documentType: string }>();

  const { data: document, isLoading } = useQuery({
    ...convexQuery(api.legal.queries.getLegalDocument, {
      documentType: documentType as any,
    }),
    enabled: !!documentType,
  });

  if (isLoading) {
    return <Loader />;
  }

  return (
    <View className="flex-1 bg-teachLoop-creamBase">
      <AppBar>
        <AppBar.Icon onPress={goBack} />
        <AppBar.Title>Back</AppBar.Title>
      </AppBar>

      <ScrollView showsVerticalScrollIndicator={false}>
        <ResponsiveContent>
          <View className="mx-5">
            <Markdown style={markdownStyles}>
              {document?.content ?? ""}
            </Markdown>

            <View className="h-8" />
          </View>
        </ResponsiveContent>
      </ScrollView>
    </View>
  );
}

export default LegalDocumentDetailScreen;
